import React from "react";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'column',
		gap: 8,
		[theme.breakpoints.up('md')]: {
			flexDirection: 'row',
			gap: 32,
		}
	},
	img: {
		width: 32,
		height: 32,
		[theme.breakpoints.up('md')]: {
			width: 40,
			height: 40,
		}
	},
	text: {
		fontWeight: 300,
		letterSpacing: '0.02em',
		fontSize: 10,
		lineHeight: '14px',
		textAlign: 'center',
		[theme.breakpoints.up('md')]: {
			fontSize: 16,
			lineHeight: '24px',
			textAlign: 'start'
		},
		[theme.breakpoints.up('xl')]: {
			fontSize: 18,
			lineHeight: '28px',
			textAlign: 'start'
		}
	}
}))

export type SkodaAdvantagesItemProps = {
	iconUrl: string;
	iconAltText: string;
	text: string;
	classes?: Partial<ReturnType<typeof useStyles>['classes']>;
}

export const SkodaAdvantagesItem = (props: SkodaAdvantagesItemProps) => {
	const { iconUrl, iconAltText, text } = props;
	const { classes } = useStyles(undefined, { props });

	return (
		<div className={classes.root}>
			<img className={classes.img} src={iconUrl} alt={iconAltText}></img>
			<span className={classes.text}>{text}</span>
		</div>
	);
}